var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"tabindex":"0"}},_vm._l((_vm.dumpValue),function(line,index){return _c('div',{key:index,staticClass:"monospace",domProps:{"innerHTML":_vm._s(line)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }